import { render, staticRenderFns } from "./BuySuccess.vue?vue&type=template&id=98bf5d2e&scoped=true"
import script from "./BuySuccess.vue?vue&type=script&lang=js"
export * from "./BuySuccess.vue?vue&type=script&lang=js"
import style0 from "./BuySuccess.vue?vue&type=style&index=0&id=98bf5d2e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bf5d2e",
  null
  
)

export default component.exports